import React, { useState, useEffect } from "react";
import moment from "moment";

const ConfirmBookingSummary = ({ bookingDetails }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    bookingDetails?.booking_details.map((detail) => {
      return setDetails(detail);
    });
  }, [bookingDetails]);

  const total =
    parseFloat(details.payment?.amount) +
    parseFloat(details.payment?.extra_charges) +
    parseFloat(details.payment?.levy_charges) +
    parseFloat(details.payment?.admin_charges) +
    parseFloat(details.payment?.cancellation_charges) +
    parseFloat(details.payment?.sms_charges) -
    parseFloat(details.payment?.discount);

  const qouteAmount =
    parseFloat(details.payment?.amount) +
    parseFloat(details.payment?.extra_charges) +
    parseFloat(details.payment?.levy_charges);

  const departure = moment(
    details.departure_date + " " + details.departure_time
  );

  const arrival = moment(details.arrival_date + " " + details.arrival_time);
  console.log(details, "details");
  return (
    <div className="flex flex-col items-center mt-8 success-container">
      <div className="flex-1 title">
        <h3 className="text-3xl font-semibold text-primary mb-7">
          Booking Details
        </h3>
      </div>
      <div className="flex flex-col items-center justify-center flex-1 w-full wrapper lg:flex-row">
        <div className="company-info lg:flex-[1.2_1_0%] flex-1 w-full lg:mb-0 mb-4">
          <div className="flex flex-col items-center px-5 mb-3 title">
            <h1 className="text-sm font-semibold text-center text-primary">
              {details.company?.name}
            </h1>
            <h3 className="text-sm font-medium text-black">
              {details.company?.type}
            </h3>
          </div>
          <div className="flex items-center justify-center image">
            <img
              src={`${details.company?.image}`}
              alt={details.company?.name}
              width={150}
              height={150}
            />
          </div>
        </div>
        <div className="booking-details lg:flex-[3_1_0%] flex-1 w-full flex lg:flex-row flex-col items-center justify-center">
          <div className="col w-full flex-[1.2_1_0%] lg:pr-3 pr-0 lg:border-r-2 border-r-0 border-black lg:mb-0 mb-3">
            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Traveling From:
              </p>
              <p className="value md:text-[15px] text-sm text-black">
                {details.company?.airport.name} airport
              </p>
            </div>
            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Departure Date:
              </p>
              <p className="value md:text-[15px] text-sm text-black">
                {departure.format("DD-MM-yyyy")}
              </p>
            </div>
            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Departure Time:
              </p>
              <p className="value md:text-[15px] text-sm text-black">
                {departure.format("HH:mm")}
              </p>
            </div>
            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">Arrival Date:</p>
              <p className="value md:text-[15px] text-sm text-black">
                {arrival.format("DD-MM-yyy")}
              </p>
            </div>
            <div className="flex items-center justify-between row">
              <p className="md:text-[15px] text-sm text-black">Arrival Time:</p>
              <p className="value md:text-[15px] text-sm text-black">
                {arrival.format("HH:mm")}
              </p>
            </div>
          </div>
          <div className="col w-full flex-[1.2_1_0%] lg:px-3 px-0 lg:border-r-2 border-r-0 border-black lg:mb-0 mb-3">
            {details?.payment?.commission_amount >0 && (
              <div className="flex items-center justify-between mb-2 row">
                <p className="md:text-[15px] text-sm text-black">
                  Actual Amount:
                </p>
                <p className="value md:text-[15px] text-sm text-black">
                  £{" "}
                  {(
                    parseFloat(qouteAmount) -
                    parseFloat(details?.payment?.discount ?? 0)
                  ).toFixed(2)}
                </p>
              </div>
            )}
            {details.payment?.commission_amount &&
              parseFloat(details.payment.commission_amount) > 0 && (
                <div className="flex items-center justify-between pb-2 mb-2 border-b-2 border-black row">
                  <p className="md:text-[15px] text-sm text-black">
                    Pay Before Arrival Price:
                  </p>
                  <p className="value md:text-[15px] text-sm text-black">
                    £{" "}
                    {(
                      parseFloat(details.payment.amount ?? 0) -
                      parseFloat(details.payment.commission_amount ?? 0)
                    ).toFixed(2)}
                  </p>
                </div>
              )}
            {details.payment?.commission_amount &&
              parseFloat(details.payment.commission_amount) > 0 && (
                <div className="flex items-center justify-between mb-2 row">
                  <p className="md:text-[15px] text-sm text-black">
                    Pay Now Price:
                  </p>
                  <p className="value md:text-[15px] text-sm text-black">
                    £
                    {(
                      parseFloat(details?.payment?.commission_amount ?? 0) +
                      parseFloat(details?.payment?.extra_charges ?? 0)
                    ).toFixed(2)}
                  </p>
                </div>
              )}

   {!(parseFloat(details?.payment?.commission_amount ?? 0) > 0) && (
  <div className="flex items-center justify-between mb-2 row">
    <p className="md:text-[15px] text-sm text-black">
      Quote Amount:
    </p>
    <p className="value md:text-[15px] text-sm text-black">
      £ {qouteAmount.toFixed(2)}
    </p>
  </div>
)}


            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Discount :
              </p>
              <div className="value md:text-[15px] text-sm text-black">
                - £ {details.payment?.discount}
              </div>
            </div>

            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Admin Charges:
              </p>
              <p className="value md:text-[15px] text-sm text-black">
                £ {details.payment?.admin_charges}
              </p>
            </div>
            <div className="flex items-center justify-between mb-2 row">
              <p className="md:text-[15px] text-sm text-black">
                Cancellation Charges:
              </p>
              <p className="value md:text-[15px] text-sm text-black">
                £ {details.payment?.cancellation_charges}
              </p>
            </div>
            <div className="flex items-center justify-between row">
              <p className="md:text-[15px] text-sm text-black">SMS Charges:</p>
              <p className="value md:text-[15px] text-sm text-black">
                £ {details.payment?.sms_charges}
              </p>
            </div>
          </div>
          <div className="flex-1 w-full border-t-2 border-b-2 border-black col lg:border-t-0 lg:border-b-0">
            <div className="flex flex-col items-center total-charges">
              <h3 className="text-black md:text-[30px] text-[20px] font-bold">
                Total
              </h3>
              <h2 className="text-primary md:text-[30px] text-[20px] font-bold">
                £ {details.payment?.total_amount ?? total.toFixed(2)}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBookingSummary;
